import {
    QuickPurchase, QuickPurchaseLine, Per, Tally
} from 'ep-bt-field-agent-proxy';

export class EpbtFaQuickPurchaseModel {

    constructor() { }

    // public lines: QuickPurchaseLine[] = [];
    // public nextLineNumber: number = 1;
    // public selectedLineIndex: number = 1;

    // public lineAdd(line: QuickPurchaseLine, adding: boolean = true) {
    //     this.nextLineNumber = this.lines.length + 1;
    //     line.lineNumber = this.nextLineNumber;
    //     line.adding = adding;
    //     this.lines.push(line);
    //     // set last added line as selected
    //     this.selectedLineIndex = this.lines.length;
    // }
}
